<template>
    <a-card :bordered="false"></a-card>
</template>

<script>
</script>